import React from "react";
import {
  Box,
  Paper,
  Typography,
  Chip,
  IconButton,
  Tooltip,
} from "@mui/material";
import { EventRepeat } from "@mui/icons-material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { Transaction } from "../utils/types";
import StatusPill from "./StatusPill";

const SettleCard: React.FC<{
  t: Transaction;
}> = ({ t }) => {
  const handleCopy = (value: string) => navigator.clipboard.writeText(value);

  const created = new Date(t.created_at);
  const updated = t.updated_at ? new Date(t.updated_at) : null;

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        borderRadius: 2,
        cursor: "pointer",
        "&:hover": { boxShadow: 6 },
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <StatusPill status={t.status} />

        <Box textAlign="right">
          <Typography fontWeight={700}>
            {t.start_amount.toLocaleString()}{" "}
            <Typography component="span" variant="caption">
              {t.currency}
            </Typography>
          </Typography>
        </Box>
      </Box>

      <Box display="flex" alignItems="center" gap={1}>
        <Typography sx={{ fontSize: "12px" }}>
          <b>ID:</b> {t.id}
        </Typography>

        <Tooltip title="Copy" placement="top">
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleCopy(t.id);
            }}
          >
            <FileCopyIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Typography sx={{ fontSize: "12px" }}>
        <b>Тип:</b> {t.transaction_type || "—"}
      </Typography>

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box textAlign="right">
          <Typography variant="caption">
            {created.toLocaleDateString("ru-RU")}{" "}
            {created.toLocaleTimeString("ru-RU", { hour12: false })}
          </Typography>

          {updated && (
            <Tooltip
              title={`Обновлено: ${updated.toLocaleDateString("ru-RU")}`}
            >
              <EventRepeat sx={{ fontSize: 14, color: "grey", ml: 0.5 }} />
            </Tooltip>
          )}
        </Box>
      </Box>
    </Paper>
  );
};
export default SettleCard;
